import serverCall from "../../serverCall";

const getAllFonts = async () => {
  return await serverCall.get("/fonts");
};

const getCategories = async () => {
  return await serverCall.get("/fonts/categories");
};

const addFont = async (data) => {
  return await serverCall.post("/fonts/admin/add", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const deleteFont = async (id) => {
  return await serverCall.delete(`/fonts/admin/${id}`);
};

const updateFont = async (id, data) => {
  return await serverCall.put(`/fonts/admin/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const FontService = { getAllFonts, getCategories, addFont, deleteFont, updateFont };
export default FontService;
